import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import Icon from '../../../Atoms/Icon'
import Button from '../../../Atoms/Button'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  justify-content: center;
  background-color: ${theme.colours.lightgrey};
  width: 45px;
`

export default class MinimiseSidebarButton extends PureComponent {
  render () {
    return (
      <Container>
        <Button lightgrey block noborder onPress={this.props.onPress}>
          <Icon
            name={this.props.sidebarMinimised ? 'arrowright' : 'arrowleft'}
            darkgrey
            size='s'
          />
        </Button>
      </Container>
    )
  }
}
